<template>
	<div>
		<div style="display: flex;align-items: center;justify-content: space-between;">
			<a-breadcrumb style="margin: 16px 0">
				<a-breadcrumb-item>主页</a-breadcrumb-item>
				<a-breadcrumb-item>{{selectFirstMenu}}</a-breadcrumb-item>
				<a-breadcrumb-item>{{selectSecondMenu}}</a-breadcrumb-item>
			</a-breadcrumb>
			<div>
				<a-button class="qinang-button-margin" icon="plus" @click="addVisible = true">新增</a-button>
				<a-button class="qinang-button-margin" icon="edit" @click="tableEdit">修改</a-button>
				<a-button class="qinang-button-margin" icon="delete" @click="tableDel">删除</a-button>
				<a-button icon="sync" @click="apiPfruleQueryList">刷新</a-button>
			</div>
		</div>
		
		<a-collapse expandIconPosition="right" activeKey="1">
			<a-collapse-panel key="1" header="票号规则查询">
				<div style="display: flex;justify-content: space-between;">
					<div style="width: 30%;display: flex;align-items: center;">
						<div style="width: 120px;">所属服务商：</div>
						<a-select v-model="query.facilitatorId" style="width: 100%;">
							<a-select-option v-for="(item,index) in facilitatorList" :value="item.facilitatorId" :key="index">{{item.facilitatorName}}</a-select-option>
						</a-select>
					</div>
					<div style="width: 30%;display: flex;align-items: center;">
						<div style="width: 120px;">规则名称：</div>
						<a-input v-model="query.pfruleName" style="width: 100%;" placeholder="请输入名称关键字查询" />
					</div>
					<div style="width: 30%;display: flex;align-items: center;justify-content: flex-end;">
						<a-button type="primary" icon="search" @click="apiPfruleQueryList">查询</a-button>
					</div>
				</div>
			</a-collapse-panel>
		</a-collapse>
		
		<div class="qinang-card">
			<a-table :row-selection="rowSelection" :columns="tableColumns" :data-source="tableData" row-key="pfruleId" :loading="tableLoading" :pagination="false">
				<span slot="pfruleName" slot-scope="pfruleName">
					<a-button type="link" @click="edit(pfruleName)" >{{pfruleName.pfruleName}}</a-button>
				</span>
				<span slot="facilitatorId" slot-scope="facilitatorId">
					{{mainNavigation[0].facilitatorName}}
				</span>
				<span slot="pfruleState" slot-scope="pfruleState">
					<span v-if="pfruleState == 2">禁用</span>
					<span v-if="pfruleState == 3">启用</span>
				</span>
				<span slot="createTime" slot-scope="createTime">
					{{qaUtil.timeFormat(createTime)}}
				</span>
			</a-table>
			<a-pagination style="text-align: right;margin: 10px;" :current="query.page" :total="query.total" :default-page-size="query.size" show-size-changer show-quick-jumper size="small" :page-size-options="['10', '20', '50']"
				:show-total="total => `共 ${total} 条记录`" @change="pageChange" @showSizeChange="showSizeChange"/>
		</div>

		<!-- 添加弹窗 -->		
		<a-modal title="添加" width="60%" :visible="addVisible" :confirm-loading="addConfirmLoading" @ok="addHandleOk" @cancel="addVisible = false" :maskClosable="false" :keyboard="false" >
			<a-form-model style="" ref="addRuleForm" :model="addForm" :label-col="{span: 4}" :wrapper-col="{span: 18}" :rules="addRules">
				<a-form-model-item label="服务商名称" has-feedback prop="facilitatorId">
					<a-select v-model="addForm.facilitatorId" >
						<a-select-option v-for="(item,index) in facilitatorList" :value="item.facilitatorId" :key="index">{{item.facilitatorName}}</a-select-option>
					</a-select>
				</a-form-model-item>
				<a-form-model-item label="票号规则名称" has-feedback prop="pfruleName">
					<a-input v-model="addForm.pfruleName" placeholder="请输入票号规则名称" />
				</a-form-model-item>
				<a-form-model-item label="启用校验位" has-feedback prop="verifyState">
					<a-radio-group name="verifyState" v-model="addForm.verifyState" @change="changeAddVerifyState">
						<a-radio :value="3">是</a-radio>
						<a-radio :value="2">否</a-radio>
					</a-radio-group>
				</a-form-model-item>
				<a-form-model-item label="票号总长度" has-feedback prop="pfruleLength">
					<a-input v-model="addForm.pfruleLength" placeholder="请输入票号总长度" :read-only="isReadOnly" />
				</a-form-model-item>
				<a-form-model-item label="前缀字符" has-feedback prop="prefixCharacter">
					<a-input v-model="addForm.prefixCharacter" placeholder="请输入前缀字符" />
				</a-form-model-item>
				<a-form-model-item label="前缀长度" has-feedback prop="prefixLength">
					<a-input v-model="addForm.prefixLength" placeholder="请输入前缀长度" />
				</a-form-model-item>
				<a-form-model-item label="流水号长度" has-feedback prop="serialLength">
					<a-input v-model="addForm.serialLength" placeholder="请输入流水号长度" />
				</a-form-model-item>
				<a-form-model-item label="后缀字符" has-feedback prop="suffixCharacter">
					<a-input v-model="addForm.suffixCharacter" placeholder="请输入后缀字符" />
				</a-form-model-item>
				<a-form-model-item label="后缀长度" has-feedback prop="suffixLength">
					<a-input v-model="addForm.suffixLength" placeholder="请输入后缀长度" />
				</a-form-model-item>
				<a-form-model-item label="是否启用" has-feedback prop="pfruleState">
					<a-radio-group name="pfruleState" v-model="addForm.pfruleState">
						<a-radio :value="3">是</a-radio>
						<a-radio :value="2">否</a-radio>
					</a-radio-group>
				</a-form-model-item>
				<a-form-model-item label="备注" has-feedback prop="remarks">
					<a-textarea placeholder="在这里输入备注" :rows="4" v-model="addForm.remarks" />
				</a-form-model-item>
			</a-form-model>
		</a-modal>
		
		<!-- 修改弹窗 -->
		<a-modal title="修改" width="60%" :visible="editVisible" :confirm-loading="editConfirmLoading" @ok="editHandleOk" @cancel="editVisible = false"  :maskClosable="false" :keyboard="false">
			<a-form-model style="" ref="editRuleForm" :model="editForm" :label-col="{span: 4}" :wrapper-col="{span: 18}" :rules="editRules">
				<a-form-model-item label="服务商名称" has-feedback prop="facilitatorId">
					<a-select v-model="editForm.facilitatorId" disabled>
						<a-select-option v-for="(item,index) in facilitatorList" :value="item.facilitatorId" :key="index">{{item.facilitatorName}}</a-select-option>
					</a-select>
				</a-form-model-item>
				<a-form-model-item label="票号规则名称" has-feedback prop="pfruleName">
					<a-input v-model="editForm.pfruleName" placeholder="请输入票号规则名称" />
				</a-form-model-item>
				<a-form-model-item label="启用校验位" has-feedback prop="verifyState">
					<a-radio-group name="verifyState" v-model="editForm.verifyState" @change="changeEditVerifyState">
						<a-radio :value="3">是</a-radio>
						<a-radio :value="2">否</a-radio>
					</a-radio-group>
				</a-form-model-item>
				<a-form-model-item label="票号总长度" has-feedback prop="pfruleLength">
					<a-input v-model="editForm.pfruleLength" placeholder="请输入票号总长度" disabled />
				</a-form-model-item>
				<a-form-model-item label="校验位长度" has-feedback prop="verifyStateNum">
					<a-input v-model="editForm.verifyStateNum" placeholder="请输入校验位长度" disabled />
				</a-form-model-item>
				<a-form-model-item label="前缀字符" has-feedback prop="prefixCharacter">
					<a-input v-model="editForm.prefixCharacter" placeholder="请输入前缀字符" />
				</a-form-model-item>
				<a-form-model-item label="前缀长度" has-feedback prop="prefixLength">
					<a-input v-model="editForm.prefixLength" placeholder="请输入前缀长度" />
				</a-form-model-item>
				<a-form-model-item label="流水号长度" has-feedback prop="serialLength">
					<a-input v-model="editForm.serialLength" placeholder="请输入流水号长度" />
				</a-form-model-item>
				<a-form-model-item label="后缀字符" has-feedback prop="suffixCharacter">
					<a-input v-model="editForm.suffixCharacter" placeholder="请输入后缀字符" />
				</a-form-model-item>
				<a-form-model-item label="后缀长度" has-feedback prop="suffixLength">
					<a-input v-model="editForm.suffixLength" placeholder="请输入后缀长度" />
				</a-form-model-item>
				<a-form-model-item label="是否启用" has-feedback prop="pfruleState">
					<a-radio-group name="pfruleState" v-model="editForm.pfruleState">
						<a-radio :value="3">是</a-radio>
						<a-radio :value="2">否</a-radio>
					</a-radio-group>
				</a-form-model-item>
				<a-form-model-item label="备注" has-feedback prop="remarks">
					<a-textarea placeholder="在这里输入备注" :rows="4" v-model="editForm.remarks" />
				</a-form-model-item>
			</a-form-model>
		</a-modal>
		
	</div>
</template>

<script>
	import moment from 'moment'
	export default {
		data() {
			return {
				moment,
				selectFirstMenu: window.sessionStorage.getItem('selectFirstMenu'),
				selectSecondMenu: window.sessionStorage.getItem('selectSecondMenu'),
				facilitatorList: [],
				// 搜索+表格-start
				query: {
					page: 1,
					size: 10,
					total: 0,
					facilitatorId: '',
					pfruleName: '',
				},
				mainNavigation:{},
				tableData: [],
				tableColumns: [
					{ title:'ID', dataIndex:'pfruleId', key:'pfruleId', align:'center'},
					{ title:'票号规则名称', key:'pfruleName', align:'center', scopedSlots:{customRender:'pfruleName'}},
					{ title:'所属服务商', key:'facilitatorId', align:'center', scopedSlots:{customRender:'facilitatorId'}},
					{ title:'票号总长度', dataIndex:'pfruleLength', key:'pfruleLength', align:'center' },
					{ title:'票号前缀', dataIndex:'prefixCharacter', key:'prefixCharacter', align:'center' },
					{ title:'流水号长度', dataIndex:'serialLength', key:'serialLength', align:'center' },
					{ title:'后缀字符', dataIndex:'suffixCharacter', key:'suffixCharacter', align:'center' },
					{ title:'状态', dataIndex:'pfruleState', key:'pfruleState', align:'center', scopedSlots:{customRender:'pfruleState'}},
					{ title:'创建时间', dataIndex:'createTime', key:'createTime', align:'center', scopedSlots:{customRender:'createTime'}},
				],
				tableLoading: false,
				tableSelectedRows: {},
				tableSelectedRowKeys:[], // 批量选中的key
				//搜索+表格-end
				// 添加弹窗-start
				isReadOnly: true,
				addVisible: false,
				addConfirmLoading: false,
				addForm: {
					facilitatorId: '',
					pfruleName: '',
					pfruleLength: 12,
					prefixCharacter: '',
					prefixLength: 0,
					serialLength: 0,
					suffixCharacter: '',
					suffixLength: 0,
					pfruleState: 3,
					remarks: '',
					verifyState: 2,
					verifyStateNum: 0,
				},
				addRules: {
					facilitatorId: [{ required: true, message: '请选择服务商', trigger: 'blur' }],
					pfruleName: [{ required: true, message: '票号规则名称不能为空', trigger: 'blur' }],
					pfruleLength: [
						{ required: true, message: '票号总长度不能为空', trigger: 'blur' },
						{ pattern: /^[1-9]\d*$/, message: '请输入大于0的整数', trigger: 'blur' },
						{
							validator: (rule, value, callback) => {
								const prefixLength = Number(this.addForm.prefixLength);
								const serialLength = Number(this.addForm.serialLength);
								const suffixLength = Number(this.addForm.suffixLength);
								const verifyStateNumber = Number(this.addForm.verifyStateNum);
								const totalLength = prefixLength + serialLength + suffixLength + verifyStateNumber;
								if (Number(value) !== totalLength) {
									callback(new Error('票号总长度必须等于前缀长度+流水号长度+后缀长度+校验位长度'));
								} else {
									callback();
								}
							},
							trigger: 'blur'
						}
					],
					prefixLength: [
						{ required: true, message: '前缀长度不能为空', trigger: 'blur' },
						{ pattern: /^[0-9]\d*$/, message: '请输入大于或等于0的整数', trigger: 'blur' }
					],
					prefixCharacter: [
						{
							validator: (rule, value, callback) => {
								const prefixLength = Number(this.addForm.prefixLength);
								if (prefixLength > 0) {
									if (!value || value.length !== prefixLength) {
										callback(new Error(`前缀字符长度必须为${prefixLength}个字符`));
									} else {
										callback();
									}
								} else {
									callback();
								}
							},
							trigger: 'blur'
						}
					],
					serialLength: [
						{ required: true, message: '流水号长度不能为空', trigger: 'blur' },
						{ pattern: /^[1-9]\d*$/, message: '请输入大于0的整数', trigger: 'blur' }
					],
					suffixLength: [
						{ required: true, message: '后缀长度不能为空', trigger: 'blur' },
						{ pattern: /^[0-9]\d*$/, message: '请输入大于或等于0的整数', trigger: 'blur' }
					],
					suffixCharacter: [
						{
							validator: (rule, value, callback) => {
								const suffixLength = Number(this.addForm.suffixLength);
								if (suffixLength > 0) {
									if (!value || value.length !== suffixLength) {
										callback(new Error(`后缀字符长度必须为${suffixLength}个字符`));
									} else {
										callback();
									}
								} else {
									callback();
								}
							},
							trigger: 'blur'
						}
					],
					// pfruleState: [{ required: true, message: '请选择', trigger: 'blur' }],
				},
				editRules: {
					facilitatorId: [{ required: true, message: '请选择服务商', trigger: 'blur' }],
					pfruleName: [{ required: true, message: '票号规则名称不能为空', trigger: 'blur' }],
					pfruleLength: [
						{ required: true, message: '票号总长度不能为空', trigger: 'blur' },
						{ pattern: /^[1-9]\d*$/, message: '请输入大于0的整数', trigger: 'blur' },
						{
							validator: (rule, value, callback) => {
								const prefixLength = Number(this.editForm.prefixLength);
								const serialLength = Number(this.editForm.serialLength);
								const suffixLength = Number(this.editForm.suffixLength);
								const verifyStateNumber = Number(this.editForm.verifyStateNum);
								const totalLength = prefixLength + serialLength + suffixLength + verifyStateNumber;
								if (Number(value) !== totalLength) {
									callback(new Error('票号总长度必须等于前缀长度+流水号长度+后缀长度+校验位长度'));
								} else {
									callback();
								}
							},
							trigger: 'blur'
						}
					],
					prefixLength: [
						{ required: true, message: '前缀长度不能为空', trigger: 'blur' },
						{ pattern: /^[0-9]\d*$/, message: '请输入大于或等于0的整数', trigger: 'blur' }
					],
					prefixCharacter: [
						{
							validator: (rule, value, callback) => {
								const prefixLength = Number(this.editForm.prefixLength);
								if (prefixLength > 0) {
									if (!value || value.length !== prefixLength) {
										callback(new Error(`前缀字符长度必须为${prefixLength}个字符`));
									} else {
										callback();
									}
								} else {
									callback();
								}
							},
							trigger: 'blur'
						}
					],
					serialLength: [
						{ required: true, message: '流水号长度不能为空', trigger: 'blur' },
						{ pattern: /^[1-9]\d*$/, message: '请输入大于0的整数', trigger: 'blur' }
					],
					suffixLength: [
						{ required: true, message: '后缀长度不能为空', trigger: 'blur' },
						{ pattern: /^[0-9]\d*$/, message: '请输入大于或等于0的整数', trigger: 'blur' }
					],
					suffixCharacter: [
						{
							validator: (rule, value, callback) => {
								const suffixLength = Number(this.editForm.suffixLength);
								if (suffixLength > 0) {
									if (!value || value.length !== suffixLength) {
										callback(new Error(`后缀字符长度必须为${suffixLength}个字符`));
									} else {
										callback();
									}
								} else {
									callback();
								}
							},
							trigger: 'blur'
						}
					],
					// pfruleState: [{ required: true, message: '请选择', trigger: 'blur' }],
				},

				
				// 添加弹窗-end
				// 修改弹窗-start
				editVisible: false,
				editConfirmLoading: false,
				editForm: {
					pfruleId: '',
					facilitatorId: '',
					pfruleName: '',
					pfruleLength: 12,
					prefixCharacter: '',
					prefixLength: '',
					serialLength: '',
					suffixCharacter: '',
					suffixLength: '',
					pfruleState: 3,
					remarks: '',
					verifyState: 2,
					verifyStateNum: 0,
				},
				// 修改弹窗-end
			};
		},
		methods: {
			//获取服务商列表
			async apiFacilitatorList() {
				const {
					data: res
				} = await this.$http.post(this.navigation.apiFacilitatorList,{staffId:window.sessionStorage.getItem('staffId')});
				if (res.code == 200) {
					this.facilitatorList = res.data
					this.query.facilitatorId = res.data[0].facilitatorId
					this.mainNavigation[0] = res.data[0]
					this.apiPfruleQueryList()
				} else {
					this.$message.error(res.msg)
				}
			},

			//表格开始-搜索
			async apiPfruleQueryList() {
				this.tableLoading = true
				for(let i=0;i<this.facilitatorList.length;i++){
					if(this.facilitatorList[i].facilitatorId == this.query.facilitatorId) {
						this.mainNavigation[0] = this.facilitatorList[i]
					}
				}
				const {
					data: res
				} = await this.$http.post(this.navigation.apiPfruleQueryList, this.query);
				if (res.code == 200) {
					this.tableData = res.data.list
					this.query.page = res.data.pages.page
					this.query.size = res.data.pages.size
					this.query.total = res.data.pages.total
					this.tableLoading = false
					this.tableSelectedRows = {}
					this.tableSelectedRowKeys = []
				} else {
					this.$message.error(res.msg)
					this.tableLoading = false
				}
			},
			pageChange(page, pageSize){
				this.query.page = page
				this.query.size = pageSize
				this.apiPfruleQueryList()
			},
			showSizeChange(current, size){
				this.query.page = current
				this.query.size = size
				this.apiPfruleQueryList()
			},
			async apiPfruleAdd() {
				const {
					data: res
				} = await this.$http.post(this.navigation.apiPfruleAdd, this.addForm);
				if (res.code == 200) {
					this.$message.success(res.msg)
					this.$refs.addRuleForm.resetFields();
					this.apiPfruleQueryList()
					this.addConfirmLoading = false
					this.addVisible = false
				} else {
					this.$message.error(res.msg)
					this.addConfirmLoading = false
				}
			},
			changeAddVerifyState(){
				if(this.addForm.verifyState == 3) {
					this.addForm.verifyStateNum = 2
				}else{
					this.addForm.verifyStateNum = 0
				}
			},
			addHandleOk() {
				this.$refs.addRuleForm.validate(valid => {
					if (valid) {
						this.apiPfruleAdd()
					} else {
					  return false;
					  this.addConfirmLoading = true
					}
				});
				
			},
			//添加弹窗事件-结束
			//修改弹窗事件-开始
			edit(item){
				let items = JSON.parse(JSON.stringify(item))

				this.editForm = items
				this.editForm.verifyStateNum = items.verifyState == 3 ? 2 : 0
				this.editVisible = true
			},
			changeEditVerifyState(){
				if(this.editForm.verifyState == 3) {
					this.editForm.verifyStateNum = 2
				}else{
					this.editForm.verifyStateNum = 0
				}
			},
			async apiPfruleEdit() {
				const {
					data: res
				} = await this.$http.post(this.navigation.apiPfruleEdit, this.editForm);
				if (res.code == 200) {
					this.$message.success(res.msg)
					this.$refs.editRuleForm.resetFields();
					this.apiPfruleQueryList()
					this.editConfirmLoading = false
					this.editVisible = false
				} else {
					this.$message.error(res.msg)
					this.editConfirmLoading = false
				}
			},
			
			editHandleOk() {
				this.$refs.editRuleForm.validate(valid => {
					if (valid) {
						this.apiPfruleEdit()
					} else {
					  return false;
					  this.editConfirmLoading = true
					}
				});
				
			},
			//修改弹窗事件-结束
			//删除
			tableDel() {
				let that = this
				if(this.tableSelectedRows.pfruleId > 0) {
					this.$confirm({
						title: '确定要删除当前选中数据吗',
						content: this.tableSelectedRows.pfruleName,
						okText: '确定',
						okType: 'danger',
						cancelText: '取消',
						onOk() {
							that.apiPfruleDel()
						},
						onCancel() {
						},
					});
				}else{
					this.$message.warning('请选择要删除的数据');
				}
			},
			//删除
			async apiPfruleDel() {
				const {
					data: res
				} = await this.$http.post(this.navigation.apiPfruleDel, {pfruleId: this.tableSelectedRows.pfruleId});
				if (res.code == 200) {
					this.$message.success(res.msg)
					this.apiPfruleQueryList()
				} else {
					this.$message.error(res.msg)
				}
			},

			tableEdit() {
				if(this.tableSelectedRows.pfruleId > 0) {
					this.edit(this.tableSelectedRows)
				}else{
					this.$message.warning('请选择要修改的数据');
				}
			}
			
		},
		computed: {
			rowSelection() {
				let that = this
				// const { selectedRowKeys } = this
				return {
					type: 'radio',
					selectedRowKeys: that.tableSelectedRowKeys,
					onChange: (selectedRowKeys, selectedRows) => {
						// console.log(selectedRows);
						that.tableSelectedRows = selectedRows[0]
						that.tableSelectedRowKeys = selectedRowKeys
					},
					// getCheckboxProps: record => ({
					// 	props: {
					// 		disabled: record.name === 'Disabled User', // Column configuration not to be checked
					// 		name: record.name,
					// 	},
					// }),
				};
			},
		},
		created() {
			this.apiFacilitatorList()
		}
	};
</script>

<style scoped>
	
</style>
